// See BC Gov standards: https://www2.gov.bc.ca/gov/content/governments/services-for-government/policies-procedures/web-content-development-guides/writing-for-the-web/web-style-guide/numbers

export const ShortDateFormat = 'YYYY-MM-DD'; //2020-01-05

export const ShortDateTimeFormat = 'YYYY-MM-DD, H:mm a'; //2020-01-05, 3:30 pm

export const MediumDateFormat = 'MMMM D, YYYY'; //January 5, 2020

export const MediumDateTimeFormat = 'MMMM D, YYYY, H:mm a'; //January 5, 2020, 3:30 pm

export const LongDateFormat = 'dddd, MMMM D, YYYY, H:mm a'; //Monday, January 5, 2020, 3:30 pm

export const LongDateTimeFormat = 'dddd, MMMM D, YYYY, H:mm a'; //Monday, January 5, 2020, 3:30 pm

export const HEALTH_ENDPOINT = '/api/misc/version';

export const PLATFORM_SRC = import.meta.env?.VITE_TARGET_PLATFORM ?? null;
